import React from 'react';

function Testimonials() {
  return (
    <section className="tc-testimonials-style1">
      <div className="marq-slider">
        <div className="swiper-wrapper">
          <div className="swiper-slide">
            <p> Creative </p>
          </div>
          <div className="swiper-slide">
            <p> Flexiable </p>
          </div>
          <div className="swiper-slide">
            <p> Dedicated </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
